import { render, staticRenderFns } from "./CodeManage.vue?vue&type=template&id=708b328a&scoped=true&"
import script from "./CodeManage.vue?vue&type=script&lang=js&"
export * from "./CodeManage.vue?vue&type=script&lang=js&"
import style0 from "./CodeManage.vue?vue&type=style&index=0&id=708b328a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708b328a",
  null
  
)

export default component.exports